import React from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Pune',
    rating: 5,
    comment:
      'Amazing quality. The vegetables are always fresh and delivered on time. This is the easiest grocery service I use.',
    avatar: 'PS'
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    location: 'Delhi',
    rating: 5,
    comment:
      'Great pricing and dependable service. The homepage feels easier to browse and ordering is much more direct.',
    avatar: 'RK'
  },
  {
    id: 3,
    name: 'Anita Patel',
    location: 'Bangalore',
    rating: 5,
    comment:
      'The produce quality is consistently strong. My family likes the freshness and the quick repeat ordering flow.',
    avatar: 'AP'
  }
];

const Testimonials = () => {
  return (
    <section className="bg-white py-6 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6 text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.25em] text-[#F4B800]">Customer Voice</span>
          <h2 className="mt-3 text-3xl font-bold text-gray-900 sm:text-4xl">What our customers say</h2>
          <p className="mt-3 text-base text-gray-600 sm:text-lg">
            Real feedback from buyers who care about freshness, speed, and consistent delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="rounded-[28px] border border-gray-100 bg-white p-8 shadow-lg transition-all duration-300 hover:shadow-xl"
            >
              <div className="mb-6 flex items-start justify-between gap-4">
                <div className="flex items-center">
                  <div className="mr-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#f4f8f4] text-sm font-bold tracking-[0.2em] text-[#2E7B52]">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.location}</p>
                  </div>
                </div>
                <span className="rounded-full bg-[#f4f7f4] px-3 py-1 text-xs font-medium text-[#2E7B52]">Verified Buyer</span>
              </div>

              <div className="mb-4 flex">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <span key={index} className="text-xl text-yellow-400">
                    *
                  </span>
                ))}
              </div>

              <p className="text-base leading-7 text-gray-600">"{testimonial.comment}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
